import { useMemo } from 'react';

import { PrimaryMultiSelect } from 'src/common/PrimaryMultiSelect/PrimaryMultiSelect';

export interface LanguageSelectOption<T extends string = string> {
  value: T;
  label: string;
  nativeLabel?: string;
}

export interface LanguageSelectValue<T extends string = string> {
  selected: T[];
  primary: T | '';
}

export interface LanguageSelectProps<T extends string = string> {
  id?: string;
  options: LanguageSelectOption<T>[];
  selected: T[];
  primary?: T | '';
  onChange: (next: LanguageSelectValue<T>) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
}

export function LanguageSelect<T extends string = string>({
  options,
  placeholder = 'Add a language...',
  ...rest
}: LanguageSelectProps<T>) {
  const selectOptions = useMemo(
    () => options.map(({ nativeLabel, ...o }) => ({ ...o, hint: nativeLabel })),
    [options]
  );
  return (
    <PrimaryMultiSelect
      {...rest}
      options={selectOptions}
      placeholder={placeholder}
      primaryLabel="Primary Language:"
      primaryBadge="primary"
      emptyText="No languages found"
      toggleLabel="Toggle language options"
      testIdPrefix="language-select"
    />
  );
}
